<!-- <div class="mb-3 col-md-1 ml-md-auto">
    <a routerLink="/orderList" class="btn btn-outline-danger btn-sm" role="button" aria-pressed="true">View Pending
        List</a>

</div> -->
<div class="card mb-4">
    <div class="card-body">
        <div>
            <div class="mb-4 d-md-flex align-items-center justify-content-between">
            </div>
            <div class="row">
                <div class="col-md-12">
                    <h3 class="text-center font-bold font-up danger-text">Confirm Order List</h3>
                    
                    <div class="row justify-content-center mt-3">
                        <div class="col-md-2">
                            <label for="orderTypeFilter">Filter by Order Type:</label>
                            <select id="orderTypeFilter" [(ngModel)]="selectedOrderType" (change)="filterOrders()" class="form-control">
                                <option value="">All</option>
                                <option value="New Order">New Order</option>
                                <option value="Repeated Order">Repeat Order</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="clientName">Client Name:</label>
                            <input type="text" id="clientName" placeholder="Client Name"   [(ngModel)]="clientName" (input)="filterOrders()" class="form-control" />
                        </div>
                        <div class="col-md-2">
                            <label for="refNo">Ref No:</label>
                            <input type="text" id="refNo"  placeholder="Ref No" [(ngModel)]="refNo" (input)="filterOrders()" class="form-control" />
                        </div>
                        <div class="col-md-2">
                            <label for="fromDate">From Date:</label>
                            <input type="date" id="fromDate" [(ngModel)]="fromDate" (change)="filterOrders()" class="form-control" />
                        </div>
                        <div class="col-md-2">
                            <label for="toDate">To Date:</label>
                            <input type="date" id="toDate" [(ngModel)]="toDate" (change)="filterOrders()" class="form-control" />
                        </div>

                        <div class="col-md-2">
    <label for="ticketNo">Ticket No:</label>

    <input
        type="text"
        class="form-control"
        list="ticketList"
        [(ngModel)]="searchTicket"
        (input)="filterOrders()"
        placeholder="Search Ticket">

    <datalist id="ticketList">
        <option
            *ngFor="let ticket of ticketNumbers"
            [value]="ticket">
        </option>
    </datalist>
</div>
<!-- 
                         <div class="col-md-2 mt-3">
                         <button
        type="button"
        class="btn btn-outline-primary" style="border:2px solid red; color:red;"
        (click)="clearFilters()">
        <i class="feather icon-x-circle" ></i> Clear Filter
    </button>
    </div> -->

                        
</div>
    <div class="row mb-2">

        <div class="col-md-2 mt-4">
                         <button
        type="button"
        class="btn btn-outline-primary" style="border:2px solid red; color:red;"
        (click)="clearFilters()">
        <i class="feather icon-x-circle" ></i> Clear Filter
    </button>
    </div>

       

                        <div class="col-md-2 mt-4">
                         
                        <button type="button" class="btn btn-outline-success  ms-2" (click)="downloadExcel()">
                            <i class="feather icon-download"></i> Export to Excel
                          </button>
                          </div>
                          
                    </div>
                </div>
            </div>
            
            <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3"><i class="feather icon-trash-2"></i></button>
            <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                <table class="table mb-0 table-centered table-bordered">
                    <thead>
                        <tr>
                            <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
                            <!-- <th>Order Type</th> -->
                            <th>Date</th>
                            <th>Ticket No</th>
                            <th>Ref No</th>
                            <th>PO No</th>
                            <th>Client Name</th>
                            <th>Job Name</th>
                            <th>Job Type</th>
                            <th>Qty Kgs</th>
                            <th>Qty Pcs</th>
                            <!-- <th>FD Option</th> -->
                            <th>Delivery Date</th>
                            <th>Status</th>
                            <th>Preview</th>

                        </tr>
                    </thead>

                    <!-- Add *ngFor loop for displaying user data -->
                    <tbody>
                        <!-- <tr *ngFor="let order of orderList"> -->
                            <tr *ngFor="let order of FullOrderList">

                            <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="order._id"></td>
                            <!-- <td [ngClass]="{ 'text-primary': order.orderType === 'Repeated Order', 'text-danger': order.orderType !== 'Repeated Order' }">
                                {{ order.orderType }}
                              </td> -->
                              
                            <!-- <td class="text-danger">{{ order.orderType}}</td> -->
                            <td>{{ formatDate(order.created).date }}</td> <!-- Use formatDate method to format the date -->
                            <td>{{ order.ticketno }}</td>
                            <td>{{ order.refNo }}</td>
                            <td>{{ order.poNo }}</td>
                            <td>{{ order.clientName}}</td>
                            <td>{{ order.jobName }}</td>
                            <td>{{ order.jobType }}</td>
                            <td>{{ order.orderKgs | number: '1.2-2' :'en-US'}}</td>

                            <td>{{ getNumber(order.orderPcs) | number:'1.0-0':'en-US' }}</td>
                            <!-- <td>{{ order.fdOption }}</td> -->
                            <td>{{ order.ddDate}}</td>
                            <td [ngClass]="{
                                'text-success': order.status === 'Confirmed',
                                'text-danger': order.status === 'Pending'
                              }">
                            {{ order.status }}
                          </td>
                          
                            <td><button  (click)="previewOrder(order._id)"><i class="feather icon-printer"></i>Preview</button></td>
                        </tr>
                    </tbody>
                </table><!--end /table (click)="saveOrder()"  routerLink="/UnsavedOrder/{{order._id}}" -->
            </div><!--end /tableresponsive-->

            <!-- <div class="pagination-container">
                <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                    <div>
                        <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems }}</p>
                    </div>

                    <div class="d-flex">
                        <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)"
                            [ngClass]="{'disabled': currentPage === 1}">
                            <i class="feather icon-chevrons-left"></i>
                        </a>

                        <ng-container *ngFor="let page of getNumberRange(ceil(totalItems / itemsPerPage))">
                            <a class="pagination-circle" [class.active]="currentPage === page"
                                (click)="onPageChange(page)">
                                {{ page }}
                            </a>
                            <span *ngIf="page < ceil(totalItems / itemsPerPage)" class="page-number-space"></span>
                        </ng-container>

                        <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)"
                            [ngClass]="{'disabled': currentPage === ceil(totalItems / itemsPerPage)}">
                            <i class="feather icon-chevrons-right"></i>
                        </a>
                    </div>

                </div>
            </div> -->

            <div class="pagination-container">
                <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                  <!-- Page range information -->
                  <div>
                    <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ pageTotalItem }}</p>
                  </div>
              
                  <!-- Pagination controls -->
                  <div class="d-flex align-items-center">
                    <!-- Previous page arrow -->
                    <a 
                      class="pagination-btn pt-2" 
                      (click)="onPageChange(page - 1)"
                      [ngClass]="{'disabled': page === 1}">
                      <i class="feather icon-chevrons-left"></i>
                    </a>
              
                    <!-- Current page number between arrows -->
                    <span class="pagination-page-number">
                      {{ page }}
                    </span>
              
                    <!-- Next page arrow -->
                    <a 
                      class="pagination-btn pt-2" 
                      (click)="onPageChange(page + 1)"
                      [ngClass]="{'disabled': page === ceil(pageTotalItem / limit)}">
                      <i class="feather icon-chevrons-right"></i>
                    </a>
                  </div>
                </div>
              </div>              
        </div>


        <ng-template #formView>
            <div class="mb-4 d-md-flex align-items-center justify-content-between">

                <div>
                    <h3>Complete Job info and Save</h3>
                    <p>Kindly check all the information and correct all mistakes and update, then save</p>
                </div>
            </div>
            <div class="form-card">
                <form (ngSubmit)="submitForm()" [formGroup]="editOrderForm">
                    <div class="row">

                        <div class="col form-group mb-3">
                            <label for="clientName" class="form-label">Customer</label>
                            <input type="text" formControlName="clientName" id="clientName" class="form-control"
                                readonly />
                        </div>

                        <div class="col form-group mb-3">
                            <label for="ticketno" class="form-label">Ticket No.</label>
                            <input type="text" formControlName="ticketno" id="ticketno" class="form-control" readonly />
                        </div>

                        <div class="col form-group mb-3">
                            <label for="poNo" class="form-label">P.O No </label>
                            <input type="text" formControlName="poNo" id="poNo" class="form-control" />
                        </div>
                        <div class="col form-group mb-3">
                            <label for="refNo" class="form-label">RefNo/Code</label>
                            <input type="text" formControlName="refNo" id="refNo" class="form-control" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group mb-3">
                            <label for="jobName" class="form-label">Job Name</label>
                            <input type="text" formControlName="jobName" id="jobName" class="form-control" />
                        </div>
                        <div class="col form-group mb-3">
                            <label for="jobType" class="form-label">Job Type</label>
                            <div class="input-group">
                                <select formControlName="jobType" id="jobType" class="form-control minimal">
                                    <option value="Roll Form">Roll Form</option>
                                    <option value="Kgs/Pcs">Kgs/Pcs</option>
                                    <option value="Sleeves">Sleeves</option>
                                    <option value="Labels">Labels</option>
                                </select>
                            </div>
                        </div>
                        <div class="col form-group mb-3">
                            <label for="orderKgs" class="form-label">Order Qty</label>
                            <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control" />
                        </div>
                        <div class="col form-group mb-3">
                            <label for="fdOption" class="form-label">FD Option</label>
                            <div class="input-group"> <select formControlName="fdOption" id="fdOption"
                                    class="form-control custom-select minimal">
                                    <option value="EMRS">EMRS</option>
                                    <option value="EMLS">EMLS</option>
                                    <option value="Readable">Readable</option>
                                    <option value="Non-Readable">Non-Readable</option>
                                    <option value="Any Direction">Any Direction</option>
                                    <option value="Direction not Required">Direction not Required</option>
                                </select> </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-end">
                        <button type="submit" class="btn  btn-outline-info">Update</button>
                        <button class="btn btn-outline-danger ms-2">Cancel</button>
                    </div>
                </form>
            </div>
        </ng-template>
    </div>
</div>